import React, { useRef } from "react";
import { useNavigate } from "react-router-dom";
import NavBar from "../../../Navbar/Navbar";
import { useDocumentKYCLogic } from "./DocumentKYCLogic";
import {
  StepBar,
  LoadingModal,
  StepError,
  Step0Choice,
  Step1IndividualInfo,
  Step2IndividualDomicile,
  Step3IndividualRevenue,
  Step1CompanyInfo,
  Step2CompanyKBIS,
  Step3CompanyProcuration,
  StepFinalDocuments,
  StepSuccess,
  Step0Model,
  Step1Client,
  Step2Instance,
  Step6LocalLink, 
} from "./DocumentKYCComponent";


export default function DocumentKYC() {
  const fileInputRef = useRef(null);
  const navigate = useNavigate();

  const { state, handlers, computed } = useDocumentKYCLogic(fileInputRef);
  const {
    step,
    loading,
    error,
    isIndividualPath,
    role,
  } = state;
  const { t, getSupportedFileTypes, finalRoute } = computed;

  // Rendu dynamique des étapes selon l'état actuel
  const renderStep = () => {
    if (step === -1) return <StepError error={error} t={t} setStep={handlers.setStep} navigate={navigate} finalRoute={finalRoute} />;
    if (step === 6) return <StepSuccess computed={computed} navigate={navigate} handlers={handlers} />; 

    switch (step) {
      case 1: return <Step0Choice state={state} handlers={handlers} computed={computed} />;
      case 2: return isIndividualPath ? <Step1IndividualInfo state={state} handlers={handlers} computed={computed} /> : <Step1CompanyInfo state={state} handlers={handlers} computed={computed} />;
      case 3: return isIndividualPath ? <Step2IndividualDomicile state={state} handlers={handlers} computed={computed} /> : <Step2CompanyKBIS state={state} handlers={handlers} computed={computed} />;
      case 4: return isIndividualPath ? <Step3IndividualRevenue state={state} handlers={handlers} computed={computed} /> : <Step3CompanyProcuration state={state} handlers={handlers} computed={computed} />;
      case 5: return <Step6LocalLink state={state} handlers={handlers} computed={computed} />;
      default: return null;
    }
  };

  return (
    <>
      <NavBar />
      <div style={{ backgroundColor: "#f2f0f0", padding: 20, minHeight: "95vh" }}>
        {state.isIndividualPath !== null && (
        <StepBar step={step} isIndividualPath={isIndividualPath} t={t} />
        )}

        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", minHeight: 400 }}>
          <LoadingModal loading={loading} t={t} />
          {!loading && renderStep()}
        </div>

        <div style={{ backgroundColor: "#f2f0f0", padding: 20 }}>
          <input
            type="file"
            ref={fileInputRef}
            onChange={handlers.handleFileUpload}
            multiple
            style={{ display: "none" }}
            accept={getSupportedFileTypes().map((type) => "." + type).join(",")}
          />
        </div>
      </div>
    </>
  );
}